<template>
  <div>
    <b-card>
      dashboard
    </b-card>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
  layout: Layout,
}
</script>
